import React from 'react';
import { Sparkles } from 'lucide-react';
import { BusinessSegment, SegmentSource } from '@/shared/types/api';
import { getSegmentMeta } from '@/shared/lib/classificationMeta';
import { cn } from '@/shared/utils/cn';

interface SegmentBadgeProps {
  segment: BusinessSegment | string;
  source?: SegmentSource;
  className?: string;
}

export const SegmentBadge: React.FC<SegmentBadgeProps> = ({ segment, source, className }) => {
  const meta = getSegmentMeta(segment);
  const isAi = source === 'Ai';

  return (
    <span
      className={cn('seg', meta.seg, isAi && 'seg-ai', className)}
      title={meta.tooltip}
      aria-label={isAi ? `${meta.label} (AI-suggested)` : undefined}
    >
      {isAi && <Sparkles className="h-3 w-3 shrink-0" aria-hidden />}
      {meta.label}
    </span>
  );
};
